<template><div><h1>安装使用(webpack)</h1>
<div class="warning">
<p>如果你从没使用过 <code>VUX</code>，请参考 <router-link to="/zh-CN/install/biolerplate.html">快速入门</router-link>。<br><br>
不推荐使用 <code>umd</code> 方式引用组件，但是如果不得不使用，可以参考 <router-link to="/zh-CN/install/umd.html">umd 构建</router-link></p>
</div>
<p>直接安装或者更新：</p>
<pre class="hljs"><code>npm install vux --save
</code></pre>
<p>或者使用 <code>yarn</code></p>
<pre class="hljs"><code>yarn add vux <span class="hljs-comment">// 安装</span>
yarn upgrade vux <span class="hljs-comment">// 更新</span>
</code></pre>
<p>如果你想直接从 Github 安装，请指定 <code>v2</code> 分支</p>
<pre class="hljs"><code>npm install git://github.com/airyland/vux.git<span class="hljs-comment">#v2</span>
</code></pre>
<p>如果你是从<code>0.x</code>更新，请参考： <router-link to="/zh-CN/install/upgrade-to-vux2.html" style="color:#42b983;">更新到<code>2.x</code></router-link></p>
<div class="warning">
<p>vux2必须配合<code>vux-loader</code>使用, 请在<code>build/webpack.base.conf.js</code>里参照如下代码进行配置：</p>
</div>
<pre class="hljs"><code><span class="hljs-keyword">const</span> vuxLoader = <span class="hljs-built_in">require</span>(<span class="hljs-string">'vux-loader'</span>)
<span class="hljs-keyword">const</span> webpackConfig = originalConfig <span class="hljs-comment">// 原来的 module.exports 代码赋值给变量 webpackConfig</span>

<span class="hljs-built_in">module</span>.exports = vuxLoader.merge(webpackConfig, {
  <span class="hljs-attr">plugins</span>: [<span class="hljs-string">'vux-ui'</span>]
})
</code></pre>
<div class="warning">
<p>vux@0.x 已经停止维护，请尽快迁移到 vue@2.x &amp; vuex@2.x &amp; vux@2.x，虽然要花点时间，但是完全值得。</p>
</div>
</div></template><script>
export default {
  head: {"title":"VUX 安装使用 | VUX - Vue 移动端 UI 组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// npm-297.vue?2dd0f907